export default {
  state: {
    responsePay: null
  },
  getters: {
    responsePay: state => state.responsePay
  },
  mutations: {
    setResponsePay(state, payload) {
      state.responsePay = payload
    },
  },
  actions: {
  }
}
